import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"
import { Href } from "../utils/helper"

const InquirySection = ({blok}) => {
  // console.log(blok)
  return (
    <div className="flex justify-center pt-10 pb-20" {...storyblokEditable(blok)}>
      <a href={Href(blok.ctaUrl)} className="bg-red-600 text-white text-lg flex flex-wrap items-center w-fit px-12 py-2 rounded-lg">
        {blok.ctaText} <img className="w-[36px] h-[13px] m-2" src="/icons/newsletter-cta-arrow-right.svg" alt="Arrow right" />
      </a>
    </div>
  )
}
  
export default InquirySection
